export default __webpack_public_path__ + "static/media/ic_eth_24.6b8ed3df.png";